module.exports = __webpack_public_path__ + "media/markers/hole_per-e4550a85.svg";